var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"i-con-h-a",attrs:{"to":{name: _vm.target}}},[_c('span',{staticClass:"nav-icon"},[_c('i',{staticClass:"i-con",class:_vm.icon})]),_c('span',{staticClass:"nav-text"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }